<template>
	<div class="footer">
		<ul class="inner">
			<li>
				<a class="has-trans" href="http://www.cmcm.com/protocol/site/privacy-cn.html">隐私政策</a>
			</li>
			<li>
				<a class="has-trans" href="http://www.cmcm.com/protocol/site/tos-cn.html">用户协议</a>
			</li>
			<li>
				<span>猎豹移动 © 2018</span>
			</li>
		</ul>
	</div>
</template>

<script>
	export default {
		name: 'Footer'
	}
</script>

<style lang="less" scoped>
	.footer {
		padding: 80px 0;

		.inner {
			font-size: 14px;
			width: 80%;
			margin: 0 auto;
			text-align: center;
			li {
				display: inline-block;
				margin: 0 8px;
				a, span {
					color: #2f3c4d;
				}
			}
		}
	}
</style>